/* unplugin-vue-components disabled */import { render } from "./DutyCheckView.vue?vue&type=template&id=497507d0&scoped=true"
import script from "./DutyCheckView.vue?vue&type=script&lang=js"
export * from "./DutyCheckView.vue?vue&type=script&lang=js"

import "./DutyCheckView.vue?vue&type=style&index=0&id=497507d0&lang=scss&scoped=true"

import exportComponent from "/root/workspace/xhzj-pc_Z77T/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-497507d0"]])

export default __exports__